
(function(){
  // formValue numbers related to redirections at the end of the onboard/quiz form.
  const PLAN_SIZES = [
    {
      name: 'Small',
      area: 3000,
      formValue: 2500
    },
    {
      name: 'Medium',
      area: 5500,
      formValue: 5000
    },
    {
      name: 'Large',
      area: 10000,
      formValue: 7500
    },
  ]
  /* Using a single "good lawn" image now
  const SIZE_IMAGES = {
    500: "https://cdn.shopify.com/s/files/1/0442/0157/4554/files/lawn_size-garage.jpg?v=1775509055",
    2000: "https://cdn.shopify.com/s/files/1/0442/0157/4554/files/lawn_size-tennis.jpg?v=1775509074",
    5000: "https://cdn.shopify.com/s/files/1/0442/0157/4554/files/lawn_size-basketball.jpg?v=1775509080",
    10000: "https://cdn.shopify.com/s/files/1/0442/0157/4554/files/lawn_size_quarter-acre.jpg?v=1776097359",
    20000: "https://cdn.shopify.com/s/files/1/0442/0157/4554/files/lawn_size-half-acre.jpg?v=1776097339",
    30000: "https://cdn.shopify.com/s/files/1/0442/0157/4554/files/lawn_size-three-quarter-acre.jpg?v=1776097330",
  }
  */
  var g_lawnSizeMap;
  var td_draw;
  var selectedFeatureId = null;

  // Map shape ID to its Popup label
  var shapeLabels = {};

  // DOM
  var deleteButtonEl = document.getElementById('delete');
  var drawButtonEl = document.getElementById('draw');
  var selectButtonEl = document.getElementById('select');

  // CONST
  const ZOOM_LEVEL = 20;
  const DEFAULT_LAT_LNG = { lat: 38.6092465, lng: -89.5255715 }

  const TRANSITION_SPEED = 300
  const BREAKPOINT = 1000
  const TARGET_URL_BASE = 'https://getlawnbright.com/pages/get-started/'
  const FROM_ESTIMATE_TRACKING = 'utm_source=calculator&utm_medium=organic&utm_campaign=lawn-size-calculator&utm_content=estimate'
  const FROM_TRACE_TRACKING = 'utm_source=calculator&utm_medium=organic&utm_campaign=lawn-size-calculator&utm_content=trace'

  let urlQueryParams = new URL(window.location.href).searchParams
  var containingModalEl = document.getElementById('lawn-size-calc').closest('modal-dialog')

  // BASIC UTILS
  function show(el) {
    el.classList.add('to-shown')
    setTimeout(()=>{
      el.removeAttribute('hidden')
      el.classList.remove('to-shown')
    }, TRANSITION_SPEED)
  }
  function hide(el) {
    el.classList.add('to-hidden')
    setTimeout(()=>{
      el.setAttribute('hidden', 'true')
      el.classList.remove('to-hidden')
    }, TRANSITION_SPEED)  
  }
  function getPlanSizeFromArea(area){
    return PLAN_SIZES.find((size) => size.area >= area)
  }

  // MAP UTILS
  function recenterMap(center){
    if(g_lawnSizeMap) {
      g_lawnSizeMap.setCenter(center)
      g_lawnSizeMap.setZoom(ZOOM_LEVEL)
    }
  }

  function calcFeatureArea(shape) {
    const coordinates = shape.geometry.coordinates[0];
    const path = coordinates.map(coord => ({ lng: coord[0], lat: coord[1] }));
    return google.maps.geometry.spherical.computeArea(path);
  }

  function calcTotalArea() {
    let resultsEl = document.getElementById('results')
    let sizeEl =  document.getElementById('size-button-container')
    let areaEl = document.getElementById('area-text-container')

    const shapes = td_draw.getSnapshot().filter(f => f.geometry.type === 'Polygon');

    if(shapes.length > 0) {
      var totalArea = shapes.reduce((total, shape) => {
        return total + calcFeatureArea(shape);
      }, 0)
      let totalAreaFeet = metersToFeet(totalArea)
      let size = getPlanSizeFromArea(totalAreaFeet)
      show(resultsEl)
      areaEl.innerHTML = `Your total lawn size is ${totalAreaFeet.toLocaleString('en-US')} ft<sup>2</sup>.`;
      if(size) {
        if(containingModalEl) {
          // either we were already on the quiz and we need to return to it
          let retrievedZip = urlQueryParams.get('default_address.zip')
          sizeEl.innerHTML = `<button class="button exit-lawn-calc" data-size="${size.formValue}" data-zip="${retrievedZip}">Continue with a <b>${size.name}</b> lawn.</button>`
          sizeEl.querySelector('.exit-lawn-calc').addEventListener('click', function(e) {
            e.preventDefault();
            containingModalEl.hide();
          });
        } else {
          // or we landed on the calc page and need to go to the quiz
          urlQueryParams.set('lawn_size', size.name.toLowerCase())
          sizeEl.innerHTML = `<a href="${TARGET_URL_BASE}?${urlQueryParams.toString()}&${FROM_TRACE_TRACKING}" class="button exit-lawn-calc">Build My <b>${size.name}</b> Lawn Plan</a>`;
        }
      } else {
        sizeEl.innerHTML = 'Looks like you have a very large lawn! <a href="https://getlawnbright.com/pages/contact-us">Please get in touch</a> for a custom quote.';
      }
      selectButtonEl.removeAttribute('disabled')

    } else {
      // no lawnShapes on the map
      setControlsMode('draw')
      hide(resultsEl)
      sizeEl.innerHTML = ''
      areaEl.innerHTML = ''
      selectButtonEl.setAttribute('disabled', 'disabled')
    }
  }

  function metersToFeet(area) {
    return parseInt(area * 10.7639);
  }

  // DRAW UTILS
  function clearSelection() {
    selectedFeatureId = null;
    hide(deleteButtonEl);
  }
  function setSelection(id) {
    selectedFeatureId = id;
    show(deleteButtonEl);
  }
  function deleteSelectedShape() {
    if(selectedFeatureId) {
      if (shapeLabels[selectedFeatureId]) {
        shapeLabels[selectedFeatureId].setMap(null);
        delete shapeLabels[selectedFeatureId];
      }
      td_draw.removeFeatures([selectedFeatureId]);
      selectedFeatureId = null;
      calcTotalArea();
      clearSelection();
    }
  }
  function setControlsMode(mode) {
    if (!td_draw) return;
    document.getElementById('controls').dataset.mode = mode
    switch (mode) {
      case 'draw':
        td_draw.setMode('polygon');
        break;
      case 'select':
        td_draw.setMode('select');
        break;
      default:
        break;
    }
  }

  /* Called from Autocomplete, or Geolocate
    * position will be different depending on callee
    * addressComponents is only available from Autocomplete
    *
    */
  async function handlePlace(position, addressComponents) {
    doneWithGeolocate(true)
    await initMapAndDrawing()
    document.getElementById('panel-2a')?.setAttribute('hidden', true)
    document.getElementById('panel-2b')?.removeAttribute('hidden')
    document.getElementById('panel-wrapper').setAttribute('data-show', 'panel-2')

    let latlng

    if(addressComponents){
      // came from autocomplete Google Places API (new)
      latlng = { lat: position.lat(), lng: position.lng() }
      setZipFromAddressComponents(addressComponents)
    } else {
      // came from Geolocation API
      latlng = {lat: position.coords.latitude, lng: position.coords.longitude}
      getZipFromLatLng(latlng)
    }
    recenterMap(latlng)
    new google.maps.marker.AdvancedMarkerElement({
      position: latlng,
      map: g_lawnSizeMap,
      title: "Your Lawn"
    });
  }

  // 'address components' object from Google Maps API
  function setZipFromAddressComponents(components) {
    var zip_component = components.filter(comp => {
      return comp.types.indexOf('postal_code') !== -1
    })
    var zip = zip_component[0]['shortText']
    urlQueryParams.set('default_address.zip',zip)
  }

  function getZipFromLatLng(latlng) {
    const geocoder = new google.maps.Geocoder();
    geocoder
      .geocode({ location: latlng })
      .then((response) => {
        if (response.results[0]) {
          setZipFromAddressComponents(response.results[0].address_components)
        } else {
          console.info('No places found at that position.');
        }
      })
      .catch((e) => console.error(`Geocoding failed due to: ${e}`));      
  }

  function geoError() {
    doneWithGeolocate(false)
    alert("Sorry, we could not determine your location. Please try entering your address instead.");
  }

  function doneWithGeolocate(success) {
    let text = success ? 'Located!' : 'Unable to locate'
    document.getElementById('loader').style.display = 'none'
    document.getElementById('geolocate-symbol').style.display = 'block'
    document.querySelector('#geolocate-button span').innerText = text
  }

  function updateLabels() {
    /**
      * A customized popup on the map.
      * @link: https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/overlay-popup#maps_overlay_popup-css
      */
    class Popup extends google.maps.OverlayView {
      position;
      containerDiv;
      constructor(position, content) {
        super();
        this.position = position;
        content.classList.add("popup-bubble");

        // This zero-height div is positioned at the bottom of the bubble.
        const bubbleAnchor = document.createElement("div");

        bubbleAnchor.classList.add("popup-bubble-anchor");
        bubbleAnchor.appendChild(content);
        // This zero-height div is positioned at the bottom of the tip.
        this.containerDiv = document.createElement("div");
        this.containerDiv.classList.add("popup-container");
        this.containerDiv.appendChild(bubbleAnchor);
        // Optionally stop clicks, etc., from bubbling up to the map.
        Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
      }
      /** Called when the popup is added to the map. */
      onAdd() {
        this.getPanes().floatPane.appendChild(this.containerDiv);
      }
      /** Called when the popup is removed from the map. */
      onRemove() {
        if (this.containerDiv.parentElement) {
          this.containerDiv.parentElement.removeChild(this.containerDiv);
        }
      }
      /** Called each frame when the popup needs to draw itself. */
      draw() {
        const divPosition = this.getProjection().fromLatLngToDivPixel(
          this.position
        );
        // Hide the popup when it is far out of view.
        const display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? "block"
            : "none";

        if (display === "block") {
          this.containerDiv.style.left = divPosition.x + "px";
          this.containerDiv.style.top = divPosition.y + "px";
        }

        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display;
        }
      }
    }

    const shapes = td_draw.getSnapshot().filter(f => f.geometry.type === 'Polygon');
    const shapeIds = shapes.map(f => f.id);

    shapes.forEach(shape => {
      const area = calcFeatureArea(shape);
      const areaText = metersToFeet(area).toLocaleString('en-US');
      
      const bounds = new google.maps.LatLngBounds();
      shape.geometry.coordinates[0].forEach(coord => bounds.extend({ lng: coord[0], lat: coord[1] }));
      const center = bounds.getCenter();

      if (shapeLabels[shape.id]) {
        const popup = shapeLabels[shape.id];
        popup.position = center;
        popup.containerDiv.querySelector('.popup-bubble').innerText = areaText;
        popup.draw();
      } else {
        const labelDiv = document.createElement('div');
        labelDiv.innerText = areaText;
        const popup = new Popup(center, labelDiv);
        popup.setMap(g_lawnSizeMap);
        shapeLabels[shape.id] = popup;
      }
    });

    Object.keys(shapeLabels).forEach(id => {
      if (!shapeIds.includes(id)) {
        shapeLabels[id].setMap(null);
        delete shapeLabels[id];
      }
    });
  }

  async function initMapAndDrawing(){
    if (td_draw) {
      td_draw.stop();
      // Clear labels if we are resetting the map
      Object.keys(shapeLabels).forEach(id => {
        shapeLabels[id].setMap(null);
        delete shapeLabels[id];
      });
    }

    await Promise.all([
      google.maps.importLibrary('maps'),
      google.maps.importLibrary('marker'),
      google.maps.importLibrary('geometry')
    ]);

    // create a new google map
    g_lawnSizeMap = new google.maps.Map(document.getElementById('map'), {
      zoom: ZOOM_LEVEL,
      center: DEFAULT_LAT_LNG,
      mapTypeId: google.maps.MapTypeId.SATELLITE,
      disableDefaultUI: true,
      zoomControl: true,
      mapId: 'LAWN_SIZE_MAP'
    });
    
    // Wait for the map to be ready before starting Terra Draw
    google.maps.event.addListenerOnce(g_lawnSizeMap, 'projection_changed', () => {
      td_draw = new terraDraw.TerraDraw({
        adapter: new terraDrawGoogleMapsAdapter.TerraDrawGoogleMapsAdapter({
          map: g_lawnSizeMap,
          lib: google.maps
        }),
        modes: [
          new terraDraw.TerraDrawPolygonMode({
            styles: {
              fillColor: "#cbf4df",
              outlineColor: "#9dd4b6",
              fillOpacity: (feature) => {
                return feature.properties?.currentlyDrawing ? 0 : .3
              },
              outlineWidth: 2,
              closingPointColor: "#ff8736"
            }
          }),
          new terraDraw.TerraDrawSelectMode({
            styles: {
              selectedPolygonColor: "#1D96B1",
              selectedPolygonOutlineColor: "#1D96B1",
              selectedPolygonFillOpacity: 0.7,
              selectedPointColor: "#ff8736"
            },
            flags: {
              polygon: {
                feature: {
                  draggable: true,
                  deletable: true,

                  coordinates: { draggable: true, deletable: true, midpoints: true }
                }
              }
            }
          })
        ]
      });

      setUpDrawingControls()

      td_draw.start();
      td_draw.setMode('polygon');

      td_draw.on('select', (id) => {
        setSelection(id);
      });

      td_draw.on('deselect', () => {
        clearSelection();
      });

      td_draw.on('finish', (id) => {
        updateLabels();
        calcTotalArea();
      })
    });
  }
  async function initAutocomplete() {
    // set up autcomplete
    var autocompleteInput = document.querySelector('gmp-place-autocomplete');
    /* 
      TODO give custom element focus after modal opens
      if(autocompleteInput.hasAttribute('autofocus')) {
        customElements.whenDefined('gmp-place-autocomplete').then(() => {
          autocompleteInput.focus();
          console.log('focus!')
        });
      }
    */
    await Promise.all([
      google.maps.importLibrary('places'),
    ]);
    autocompleteInput.addEventListener('gmp-select', async({placePrediction}) => {
      const place = placePrediction.toPlace()
      await place.fetchFields({
        fields: ['formattedAddress', 'location', 'addressComponents']
      })
      handlePlace(place.location, place.addressComponents)
    })
  }

  function initGeoLocate() {
    let geoLocateContainer = document.getElementById('geolocate');
    let geoLocateBtn = document.getElementById('geolocate-button');
    if ('geolocation' in navigator) {
      // geolocation is available, show button etc.
      show(geoLocateContainer)
      geoLocateBtn.addEventListener('click', () => {
        document.getElementById('loader').style.display = 'block'
        document.getElementById('geolocate-symbol').style.display = 'none'
        document.querySelector('#geolocate-button span').innerText = 'Getting location...'
        navigator.geolocation.getCurrentPosition(handlePlace, geoError, {
          enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 27000,
        });
      })
    } else {    
      // geolocation IS NOT available
      console.info('Geolocation API is not available')
    }
  }
  function setUpDrawingControls() {
    // Setup UI control listeners once
    deleteButtonEl.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      deleteSelectedShape();
    });

    drawButtonEl.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      setControlsMode('draw');
    });

    selectButtonEl.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      setControlsMode('select');
    });

    window.addEventListener("keydown", (event) => {
      if (event.defaultPrevented) return;
      if ((event.key === 'Backspace' || event.key === 'Delete') && selectedFeatureId){
        event.stopPropagation();
        event.preventDefault();
        deleteSelectedShape();
      }
    });
  }
  async function init() {
    initAutocomplete()
    // initGeoLocate()
  }

  init();

  // SHOW/HIDE PANELS //
  var estimateByReference = document.getElementById('estimate-by-reference');
  var wrapper = document.getElementById('panel-wrapper')
  var figure = document.getElementById('size-description')
  var estimators = document.querySelectorAll('.estimator')
  var backBtns = document.querySelectorAll('.back-btn')
  // NOTE at the moment there is only one
  var quizLinks = document.querySelectorAll('.js-quiz-link')

  function updateSizeDisplay(selectedValue) {
      valueAsNumber = parseInt(selectedValue.replace(/,/g, ''))
      // NOTE We just show one image for all now
      // let sizeImage = SIZE_IMAGES[valueAsNumber]
      // figure.querySelector('img').setAttribute('src', sizeImage)
      document.querySelectorAll('.lawn-area-est').forEach((el) => {
        el.innerText = selectedValue
      })
      let planSize = getPlanSizeFromArea(valueAsNumber)
      // TODO use show/hide functions
      if(planSize) {
        document.getElementById('size-in-range')?.removeAttribute('hidden')
        document.getElementById('size-too-big')?.setAttribute('hidden', true)
        urlQueryParams.set('lawn_size', planSize.name.toLowerCase())
        quizLinks?.forEach(link => link.setAttribute('href', `${TARGET_URL_BASE}?${urlQueryParams.toString()}&${FROM_ESTIMATE_TRACKING}`))
      } else {
        document.getElementById('size-in-range')?.setAttribute('hidden', true)   
        document.getElementById('size-too-big')?.removeAttribute('hidden')    
      }
  }
  estimators.forEach((select) => {
    select.addEventListener('change', (e) => {
      // update the other selector to match
      // estimators.forEach((otherSelect) => {
      //   if (otherSelect !== e.target) {
      //     otherSelect.value = e.target.value;
      //   }
      // });
      // show the right image and size text
      updateSizeDisplay(e.target.value)
    })
  })

  backBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      wrapper.setAttribute('data-show', 'panel-1')
    })
  })
  estimateByReference?.addEventListener('submit', (e) => {
    e.preventDefault()
    e.stopPropagation()
    // get the first selector in case it has a previously-selected value
    let selectedValue = document.querySelector('.estimator').value
    let errorEl = document.getElementById('estimator-error')
    if(selectedValue != "") {
      document.getElementById('panel-2a')?.removeAttribute('hidden')
      document.getElementById('panel-2b')?.setAttribute('hidden', true)
      updateSizeDisplay(selectedValue)
      wrapper.setAttribute('data-show', 'panel-2')
      errorEl.innerText = ""
    } else {
      errorEl.innerText = "Please make a selection"
    }
  })
})();